export class LoggerService {
  log(message: string, data?: unknown) {
    // eslint-disable-next-line no-console
    console.log(message, data, new Date());
  }
}
